"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { LuCheck } from "react-icons/lu";
import { cn } from "../../lib/utils";
import { CHECKBOX_STYLES } from "./constants";
import { CheckboxProps, CheckboxWithLabelProps } from "./types";
import { Typography } from "../Typography";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(CHECKBOX_STYLES.root, className)}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={CHECKBOX_STYLES.indicator}>
      <LuCheck className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

const CheckboxWithLabel = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxWithLabelProps
>(({ label, id, labelColor, labelSize = "sm", labelWeight = "medium", className, ...props }, ref) => {
  const generatedId = React.useId();
  const checkboxId = id || generatedId;

  return (
    <div className={CHECKBOX_STYLES.container}>
      <Checkbox id={checkboxId} ref={ref} className={`${className} bg-white`} {...props} />
      <Typography
        as="label"
        htmlFor={checkboxId}
        color={labelColor}
        size={labelSize}
        weight={labelWeight}
        className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
      >
        {label}
      </Typography>
    </div>
  );
});
CheckboxWithLabel.displayName = "CheckboxWithLabel";

export { Checkbox, CheckboxWithLabel };
